import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    dark: {
      backgroundColor: "#72ABDC",
      border: "none",
      color: "white"
    }

  },
  mutations: {},
  actions: {},
  modules: {}
})